import React from 'react';
import './LegalPages.css';

function TermsOfService() {
  return (
    <div className="legal-container">
      <div className="legal-header">
        <div className="legal-shapes">
          <div className="legal-shape shape1"></div>
          <div className="legal-shape shape2"></div>
          <div className="legal-shape shape3"></div>
        </div>
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: 07/24/2026</p>
      </div>

      <div className="legal-content">
        <div className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing or using ZipCode AutoFill, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any part of these terms, you may not use our service.</p>
        </div>

        <div className="legal-section">
          <h2>2. User Accounts</h2>
          <p>To use our service, you must create an account using a valid email address and a password. You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.</p>
        </div>

        <div className="legal-section">
          <h2>3. Services Provided</h2>
          <p>ZipCode AutoFill connects to your HubSpot portal and automatically fills City, State, County, and Country fields based on the postal code entered into contact or company records. A valid HubSpot account and portal connection is required.</p>
          <p>ZIP code and location data is provided in part by the <a href="https://simplemaps.com/data/us-zips">SimpleMaps U.S. ZIP Codes Database</a> and the <a href="https://developers.google.com/maps/documentation/geocoding">Google Maps Platform Geocoding API</a>.</p>
        </div>

        <div className="legal-section">
          <h2>4. Payment</h2>
          <p>We offer a credit-based system for using our services, which are purchased via Stripe. All payments are handled securely, and we do not store your payment information. For issues regarding payments, refunds, or credits, please contact us at info@zipcodeautofill.com.</p>
        </div>

        <div className="legal-section">
          <h2>5. Cookies</h2>
          <p>We use cookies to manage login sessions and facilitate payment processing through Stripe. By using our site, you consent to the use of these cookies.</p>
        </div>

        <div className="legal-section">
          <h2>6. Refunds and Disputes</h2>
          <p>If you have any issues related to refunds, payments, or service use, please contact us at info@zipcodeautofill.com for resolution.</p>
        </div>

        <div className="legal-section">
          <h2>7. Termination</h2>
          <p>We reserve the right to suspend or terminate your account if we suspect a breach of these Terms or misuse of the service.</p>
        </div>

        <div className="legal-section">
          <h2>8. Changes to Terms</h2>
          <p>We reserve the right to modify these Terms at any time. We will notify you of significant changes via email or through the website.</p>
        </div>

        <div className="legal-section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions regarding these Terms of Service, please contact us at info@zipcodeautofill.com.</p>
        </div>
      </div>

      <div className="legal-contact">
        <h3>Need Clarification on Our Terms?</h3>
        <p>If you have any questions about our terms or need assistance, our team is ready to help.</p>
        <a href="mailto:info@zipcodeautofill.com" className="legal-contact-button">Get in Touch</a>
      </div>
    </div>
  );
}

export default TermsOfService;
